import React, { useState, useEffect } from 'react';
import { Avatar, Box, Button, CardContent, Stack, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Alert from '@mui/material/Alert';
import { api } from 'src/Api';
import { t } from 'i18next';

export default function BannerModal({ handleClose, product, refreshAdmin }) {
  const [loading, setloading] = useState(false);
  const [alert, setalert] = useState({ visible: false, message: '' });
  const [banerheading, setbannerheading] = useState('');
  //   const [bannertype, setbannertype] = useState('');
  const [file, setfile] = useState({ image: null });

  const [bannerurl, setbannerurl] = useState('');
  function SaveProduct() {
    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdata = new FormData();

    product && formdata.append('id', product?.id);
    // formdata.append('name', name);
    banerheading && formdata.append('heading', banerheading);
    formdata.append('type', 'image');
    bannerurl && formdata.append('url', bannerurl);
    if (file && file.file) {
      formdata.append('media', file.file);
    }
    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };
    setloading(true);

    fetch(product ? api.edit_banner : api.add_banner, requestOptions)
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          return response.text();
        } else {
          return response.json().then((result) => {
            setalert({ visible: true, message: result.error });
          });
        }
      })
      .then((result) => {
        const response = JSON.parse(result);
        refreshAdmin();
      })
      .catch((error) => {
        console.log('error', error);
      })
      .finally(() => setloading(false));
  }
  const [objAfter, setobjAfter] = useState({
    name: product?.name,
    file: false
  });

  useEffect(() => {
    if (product?.heading !== 'null') {
      setbannerheading(product?.heading);
      setbannerurl(product?.url);
      setfile({ image: product?.media });
    }
  }, [product]);
  console.log('bannerurl', typeof bannerurl);
  return (
    <Box
      p={1}
      mt={2}
      style={{
        width: '100%',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Typography variant="h4" style={{ fontWeight: 'bold', textAlign: 'center' }}>
        {product ? 'Edit Banner' : 'Banner'}
      </Typography>

      <Box display={'flex'} sx={{ width: '90%', mt: 4, flexDirection: 'column' }}>
        <TextField
          id="outlined-error-helper-text"
          fullWidth
          label="Heading"
          value={banerheading}
          onChange={(val) => {
            setbannerheading(val.target.value);
          }}
          type="text"
          variant="outlined"
          display="inline"
        />
        <Box mt={2}></Box>

        <TextField
          id="outlined-error-helper-text"
          fullWidth
          label="Url"
          value={bannerurl}
          onChange={(val) => {
            console.log('val??????????????', val.target.value);
            setbannerurl(val.target.value);
          }}
          type="text"
          variant="outlined"
          display="inline"
        />
      </Box>

      <CardContent
        style={{
          flex: 1,
          width: '95%'
        }}
      >
        <Stack
          mb={2}
          direction={{ xs: 'column' }}
          style={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            justifyContent: 'center'
          }}
          className="image_center"
        >
          <Box
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              width: '100%'
            }}
          >
            {file?.image ? (
              <img
                alt="Banner"
                src={objAfter?.file ? file?.image : file?.image}
                style={{
                  borderWidth: 1,
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: 4,
                  boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)'
                }}
              />
            ) : (
              <Box
                style={{
                  width: '100%',
                  height: 150,
                  backgroundColor: '#f0f0f0',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: 4,
                  border: '2px dashed #ccc',
                  boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)'
                }}
              >
                <Typography variant="h6" color="textSecondary">
                  Add Banner
                </Typography>
              </Box>
            )}
            <Button
              style={{
                width: 150,
                height: 40,
                borderRadius: 20,
                marginTop: 20,
                fontSize: 14
              }}
              variant="outlined"
              component="label"
            >
              {file?.image ? `Change Banner` : `Add Banner`}
              <input
                type="file"
                hidden
                accept="image/*"
                onChange={(e) => {
                  setobjAfter({ file: true });
                  setfile({
                    image: URL.createObjectURL(e.target.files[0]),
                    file: e.target.files[0]
                  });
                }}
              />
            </Button>
          </Box>
        </Stack>
        {alert && alert.visible && <Alert severity="error">{alert.message}</Alert>}
      </CardContent>
      <Box mb={2} />

      <Box
        p={2}
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          width: '90%'
        }}
      >
        <LoadingButton
          disabled={false}
          loading={loading}
          sx={{
            marginRight: 1
          }}
          onClick={SaveProduct}
          color="primary"
          variant="contained"
        >
          Save
        </LoadingButton>
        <LoadingButton onClick={handleClose} variant="outlined">
          Close
        </LoadingButton>
      </Box>
    </Box>
  );
}
